import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { Icon } from "@portal/lib/icons/icons";
import styled from "styled-components";
import { StyledFilterBlock } from "./style";
export interface FilterBlockProps {
  title: string;
  filterValues?: string;
  open: boolean;
  hideClear?: boolean;
  toggleOpen: () => void;
  onRemove?: () => void;
  isDefault?: boolean;
  onReset?: () => void;
  hideReset?: boolean;
  hasSymbol?: boolean;
}

export const ClearIcon = styled(Icon)`
  background: var(--primary-2);
  border-radius: 50%;
  color: var(--primary-7);
  position: absolute;
  top: -6px;
  left: -6px;
  z-index: 1;
  cursor: pointer;

  &:hover {
    background: var(--primary-4);
    color: var(--primary-9);
  }
`;

function FilterBlock(props: FilterBlockProps) {
  const {
    title,
    filterValues,
    open,
    hideClear = false,
    toggleOpen,
    onRemove: onClear,
    isDefault = false,
    onReset,
    hideReset,
  } = props;

  const Values = (
    <TypographyText
      fs="14"
      strong
      style={{ color: "var(--primary-7)", maxWidth: "200px", lineHeight: 1.5 }}
      ellipsis={{ tooltip: filterValues }}
    >{`${filterValues}`}</TypographyText>
  );
  const ClearButton = (
    <HideWrapper hide={hideClear || isDefault}>
      <ToolTip title={"Remove Filter"}>
        <ClearIcon
          icon={["far", "times-circle"]}
          color="var(--primary-4)"
          onClick={onClear}
          style={{ cursor: "pointer" }}
          className="show-on-hover"
        />
      </ToolTip>
    </HideWrapper>
  );
  const ChevIcon = (
    <Icon
      icon={open ? ["far", "chevron-up"] : ["far", "chevron-down"]}
      color="var(--primary-7)"
      style={{ cursor: "pointer" }}
      onClick={toggleOpen}
    />
  );

  const RefreshIcon = (
    <HideWrapper hide={Boolean(hideReset)}>
      <ToolTip title={"Reset Filters"}>
        <Icon
          icon={["far", "undo"]}
          color="var(--primary-4)"
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            onReset?.();
          }}
        />
      </ToolTip>
    </HideWrapper>
  );
  const Prefix = (
    <>
      {title}:&nbsp;
      {Values}
    </>
  );
  const Suffix = (
    <Flex align="center" space={"8"}>
      {ChevIcon}
      {RefreshIcon}
    </Flex>
  );
  return (
    <StyledFilterBlock icon={Suffix} iconPosition="end" onClick={toggleOpen}>
      {ClearButton}
      {Prefix}
    </StyledFilterBlock>
  );
}

export { FilterBlock };
